'use strict';

var value;

module.exports = function(name) {
  value = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return value ? value.pop() : '';
};



//////////////////
// WEBPACK FOOTER
// ./lib/cookies/get.js
// module id = 9
// module chunks = 1 3